import React, { useMemo, useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EmailIcon from '@mui/icons-material/Email';

const getNextStageLabel = (stage) => {
  if (stage === 'DAF') return 'Promote to D2C2';
  if (stage === 'D2C2') return 'Promote to Complete';
  return 'Promote';
};

const getPreviousStageLabel = (stage) => {
  if (stage === 'Complete') return 'Demote to D2C2';
  if (stage === 'D2C2') return 'Demote to DAF';
  return 'Demote';
};

const BuySellRowActions = ({ row, onEdit, onDelete, onPromote, onDemote, onForceSendEmail }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const promoteDisabled = useMemo(() => row?.buySellStage === 'Complete', [row?.buySellStage]);
  const demoteDisabled = useMemo(() => row?.buySellStage === 'DAF', [row?.buySellStage]);
  const forceSendDisabled = useMemo(
    () => row?.buySellStage !== 'DAF' && row?.buySellStage !== 'D2C2',
    [row?.buySellStage]
  );

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (action) => {
    handleClose();
    action?.(row);
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen} aria-label="Row actions">
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu anchorEl={anchorEl} open={isOpen} onClose={handleClose}>
        <MenuItem onClick={() => handleAction(onEdit)}>
          <ListItemIcon>
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>
        <MenuItem onClick={() => handleAction(onPromote)} disabled={promoteDisabled}>
          <ListItemIcon>
            <ArrowForwardIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={getNextStageLabel(row?.buySellStage)} />
        </MenuItem>
        <MenuItem onClick={() => handleAction(onDemote)} disabled={demoteDisabled}>
          <ListItemIcon>
            <ArrowBackIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary={getPreviousStageLabel(row?.buySellStage)} />
        </MenuItem>
        <MenuItem onClick={() => handleAction(onForceSendEmail)} disabled={forceSendDisabled}>
          <ListItemIcon>
            <EmailIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Force Send Email" />
        </MenuItem>
        <MenuItem onClick={() => handleAction(onDelete)}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Delete" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default BuySellRowActions;
